import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Button } from '@chakra-ui/react';

import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import Spinner from '../../components/Spinner';
import { analyticsIds } from '../../constants/analyticsIds';
import { ChakraSizes } from '../../constants/chakraSizes';
import { setCurrentPage } from '../../redux/modules/app';
import {
  emailEditorReset,
  getAllCompanyEmailTemplates,
  getCompanyCodes,
  getSearchQueryRecipientsPage,
  selectDefaultTemplate,
  selectSearchParams,
  setDefaultTemplates
} from '../../redux/modules/emails';
import { showModal } from '../../redux/modules/modal';
import safeJsonParse from '../../utils/safeJsonParse';

import EmailContentDropdown from './components/EmailContentDropdown';
import RecipientsDropdown from './components/RecipientsDropdown';
import SendEmailsModal from './components/SendEmailsModal';
import SignatureDropdown from './components/SignatureDropdown';

import './style.scss';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const EmailEditorPage = () => {
  const dispatch = useDispatch();
  const defaultTemplate = useSelector(selectDefaultTemplate);
  const searchParams = useSelector(selectSearchParams);
  const { companyId } = useParams();
  const query = useQuery();

  function confirmSendEmail() {
    dispatch(showModal(
      SendEmailsModal,
      { size: ChakraSizes.Small }
    ));
  }

  useEffect(() => {
    dispatch(setCurrentPage('Email Editor'));
    dispatch(getAllCompanyEmailTemplates(companyId));
    dispatch(setDefaultTemplates(companyId));
    dispatch(getCompanyCodes(companyId));
    dispatch(getSearchQueryRecipientsPage(safeJsonParse(query.get('query'))));

    return () => dispatch(emailEditorReset());
  }, [dispatch]); // eslint-disable-line

  if (!defaultTemplate) return <Spinner />;

  return (
    <Page>
      <PageHeader title="Email Insurance Request to Vendor / Contractor">
        <Button
          className="sendButton defaultState"
          data-analytics-id={analyticsIds.emailEditorPage.confirmSendEmailModalButton}
          onClick={() => confirmSendEmail()}
        >
          Send Email
        </Button>
      </PageHeader>
      <RecipientsDropdown searchParams={searchParams} />
      <Box p={2} />
      <EmailContentDropdown />
      <Box p={2} />
      <SignatureDropdown />
      <Box p={2} />
    </Page>
  );
};

export default EmailEditorPage;
